import { render, staticRenderFns } from "./customertype.vue?vue&type=template&id=4c247696&scoped=true&"
import script from "./customertype.vue?vue&type=script&lang=js&"
export * from "./customertype.vue?vue&type=script&lang=js&"
import style0 from "./customertype.vue?vue&type=style&index=0&id=4c247696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c247696",
  null
  
)

export default component.exports